var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg93",
    xmlSpace: "preserve",
    width: 19,
    height: 19,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs97"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path105"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g99",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g103",
    clipPath: "url(#clipPath107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g109",
    transform: "translate(478.874,160.2329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -122.733 c 0,-16.568 -13.432,-30 -30,-30 h -385.748 c -16.568,0 -30,13.432 -30,30 V -81",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g113",
    transform: "translate(367.2603,37.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -304.084 c -16.596,0 -30.05,13.454 -30.05,30.05 v 372.626 c 0,16.596 13.454,30.05 30.05,30.05 H 81.563 c 16.597,0 30.051,-13.454 30.051,-30.05 V 111.614 c 0,-7.97 -3.166,-15.614 -8.802,-21.249 L 21.249,8.802 C 15.613,3.166 7.97,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path115"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117",
    transform: "translate(354.9458,37.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 13.598,0 24.622,11.023 24.622,24.622 v 50.063 c 0,13.598 11.023,24.622 24.621,24.622 h 50.064 c 13.598,0 24.621,11.023 24.621,24.621",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path119"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g121",
    transform: "translate(121.7998,363.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -88.674",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g125",
    transform: "translate(478.874,363.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -327.074",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g129",
    transform: "translate(118.0498,425.3672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.454,0 -15.307,6.853 -15.307,15.307 v 48.519 c 0,8.454 6.853,15.307 15.307,15.307 h 3.443 c 8.454,0 15.307,-6.853 15.307,-15.307 V 44.859",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g133",
    transform: "translate(390.5068,425.3672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -8.454,0 -15.307,6.853 -15.307,15.307 v 48.519 c 0,8.454 6.853,15.307 15.307,15.307 h 3.443 c 8.454,0 15.307,-6.853 15.307,-15.307 V 44.859",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g137",
    transform: "translate(120.9834,268.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path139"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g141",
    transform: "translate(222.8989,268.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g145",
    transform: "translate(324.8149,268.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path147"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g149",
    transform: "translate(426.731,268.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g153",
    transform: "translate(120.9834,175.2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path155"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g157",
    transform: "translate(222.8989,175.2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g161",
    transform: "translate(324.8149,175.2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g165",
    transform: "translate(426.731,173.0464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path167"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g169",
    transform: "translate(120.9834,82.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g173",
    transform: "translate(222.8989,82.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path175"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g177",
    transform: "translate(281.958,115.0576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 10.299 c 0,3.946 3.198,7.143 7.143,7.143 h 35.714 c 3.945,0 7.143,-3.197 7.143,-7.143 v -35.714 c 0,-3.945 -3.198,-7.143 -7.143,-7.143 H 7.143 C 3.198,-32.558 0,-29.36 0,-25.415",
    style: {
      fill: "none",
      stroke: "#f77f00",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path179"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/calendar-active.5254a4644b4a6283306d9a22550533fb.svg";
export { ForwardRef as ReactComponent };